import React from "react";
import _ from "lodash";

import {useTabsSharedDataContext} from "../../../CustomerDashboardV2/components_v2/TabsSharedData/TabsSharedData";
import {getHashValue} from "../../../CustomerDashboardV2/utils";
import {PortfolioManagerResource} from "../../../../utils/api";
import {displayErrorSnackBar, displaySuccessSnackBar} from "../../../../components/SnackbarProvider/actions";

const SHARED_DATA_KEY = 'customer-asset-sync-data';

export function useAssetsLiabilitiesSyncData(customerId, flagName, onUpdate){
  const [data, setData] = React.useState({
    data: null,
    loading: true,
    error: null,
    updatedAt: +new Date(),
  });

  const hashKey = getHashValue([customerId]);
  const sharedData = useTabsSharedDataContext();

  const _setState = (state) => {
    // It is not possible to sync data with shared data in
    // hook because hook is not executed if component destroyed
    setData(state);
    sharedData.setDataValue(SHARED_DATA_KEY, hashKey, state);
  };

  const fetch = async () => {

    _setState({
      data: null,
      loading: true,
      error: null,
      updatedAt: +new Date()
    });

    try {
      const response = await PortfolioManagerResource.at(`customer/${customerId}/other-assets/sync-assets-liabilities/`).get();

      _setState({
        data: response,
        loading: false,
        error: null,
        updatedAt: +new Date()
      })

    } catch (error) {
      _setState({
        data: null,
        loading: false,
        error: error,
        updatedAt: +new Date()
      })
    }
  };

  const setSynced = async (dispatch, items) => {
    // TODO: is there a better way to get dispatch inside hook?

    try {
      const res = await PortfolioManagerResource.at(`customer/${customerId}/other-assets/update-sync-assets-liabilities/`).patch({
        [flagName]: true,
        items,
      });
      dispatch(displaySuccessSnackBar('Ihre Änderung wurde erfolgreich gespeichert.'));

      if(!_.isEmpty(items)) {
        onUpdate(res);
      }

      _setState({
        data: {...data.data, [flagName]: true},
        loading: false,
        error: null,
        updatedAt: +new Date()
      });

      return true;
    } catch (e) {
      dispatch(displayErrorSnackBar('Ihre Änderung wurde leider nicht gespeichert. Bitte versuchen Sie es später nochmal.'))
    }

    return false;
  };

  React.useEffect(() => {
    if (!!customerId) {
      const sharedPortfolioData = !!sharedData
        ? sharedData.getDataValue(SHARED_DATA_KEY, hashKey)
        : undefined;

      if (!!sharedPortfolioData && !sharedPortfolioData.errors) {
        // sync internal hook data with shared data.
        setData(sharedPortfolioData);
        return;
      }

      // fetch data if there is no shared data or shared data was loaded with error
      // check if data fetched for the first time (updatedAt is undefined) to prevent infinite data reloading
      // in case of data loading error, so data will be requested again only if tab changed
      if (!data.updatedAt || !sharedPortfolioData) {
        fetch();
      }
    }
  }, [customerId]);

  return [data, setSynced]
}